import AnnoncesCard from "SanityComponents/LocationAnnoncesLp/AnnoncesCard";
import Carousel from "components/v3/common/cardSlider/Carousel";
import React, { useEffect, useRef, useState } from "react";
import styles from "../ListingsSortAndMapSwitch/ListingsSortAndMapSwitch.module.css";
import VoirPlusCard from "./VoirPlusCard";
import useTranslation from "next-translate/useTranslation";
import PopupCarousel from "components/v3/common/cardSlider/PopupCarousel";
import { useDispatch, useSelector } from "react-redux";
import CarouselScratch from "components/v3/common/CarouselScratch";
import {
  actions as ListingreducerActions,
  selectors as ListingreducerSelectors,
} from "redux/slices/v2/ListingReducer";
import ListingPopupCard from "components/v2/Listings/ListingPopupCard";

function index({ listings, isMobile, favListings, onListingPress }) {
  const { t, lang } = useTranslation("commonAnnonces");

  const dispatch = useDispatch();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [length, setlength] = useState(listings.length);
  const mapListing = useSelector(ListingreducerSelectors.mapListingSelactor);
  useEffect(() => {
    if (mapListing.listing) {
      setCurrentIndex(0);
    }
  }, [mapListing.listing]);
  useEffect(() => {
    if (currentIndex < 10) {
      if (listings[currentIndex]) {
        dispatch(
          ListingreducerActions.setActiveListingId(listings[currentIndex]._id)
        );
      }
    }
  }, [currentIndex]);

  return (
    <div
      style={{
        bottom: "60px",
      }}
      className={styles.carousel_container}
    >
      {/* <CarouselScratch */}
      <PopupCarousel
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
        length={length}
        width={277}
      >
        {listings.length > 9 ? (
          <>
            {listings.slice(0, 10).map((list, i) => {
              return (
                <>
                  <ListingPopupCard
                    key={i}
                    listing={list}
                    onListingPress={() => onListingPress(list)}
                    defaultLiked={favListings.includes(list._id)}
                  />
                </>
              );
            })}
            <VoirPlusCard t={t} lang={lang} />
          </>
        ) : (
          listings.map((list, i) => {
            return (
              <>
                <ListingPopupCard
                  key={i}
                  listing={list}
                  onListingPress={() => onListingPress(list)}
                  defaultLiked={favListings.includes(list._id)}
                />
              </>
            );
          })
        )}
      </PopupCarousel>
    </div>
  );
}

export default index;
